import {StatusDetailRes} from "./status.contract";
import {Type} from 'class-transformer';

export class TransitionDetailRes {
    id!: number;
    label!: string;
    @Type(() => StatusDetailRes)
    fromWorkflowStatus!: StatusDetailRes;
    @Type(() => StatusDetailRes)
    toWorkflowStatus!: StatusDetailRes;

    constructor(id?: number, s?: StatusDetailRes, t?: StatusDetailRes, l?: string) {
        if (id !== undefined && s !== undefined && t !== undefined && l !== undefined) {
            this.id = id;
            this.fromWorkflowStatus = s;
            this.toWorkflowStatus = t;
            this.label = l;
        }
    }
}

export class TransitionCreateReq {
    workflowId!: number;
    fromStatusId!: number;
    toStatusId!: number;
}